import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../common/components/T';
import css from './Status.module.scss';
import classnames from 'classnames';
import CircleLoader from '../../../plug/CircleLoader';
import { generateGridStyles } from '../../components/helpers';
import { generateUniqueId } from '../../../../common/utils/utils';
import { Tooltip, svgSprite } from '../../../../hybrid/wrappers';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';

const Status = ({ getHandlers, val, translation, gridStyles, name }) => {
    const { stylers, classes, existCl } = generateGridStyles(gridStyles, name);

    const widthDimensions = useWindowDimensions();
    const screenWidth = useMemo(() => widthDimensions < 768, [widthDimensions]);

    const getStatusText = (value, male, variant) => {
        switch (value) {
            case 'inprocessing':
            case 'waiting':
                return t('grid-inprocessing', 'В обработке', 'widget', translation, 'grid');
            case 'active':
            case 'open':
                return male
                    ? t('grid-Men-Active', 'Активный', 'widget', translation, 'grid')
                    : t('grid-Woman-Acrive', 'Активна', 'widget', translation, 'grid');
            case 'hidden':
                if (variant) return t('grid-NotActive', 'Не активна', 'widget', translation, 'grid');
                return male
                    ? t('grid-Men-Hidden', 'Скрытый', 'widget', translation, 'grid')
                    : t('grid-Woman-Hidden', 'Скрытая', 'widget', translation, 'grid');
            case 'deleted':
                return male
                    ? t('gridDeletedUser', 'Удален', 'widget', translation, 'grid')
                    : t('grid-Woman-Delete', 'Удалена', 'widget', translation, 'grid');
            case 'new':
                return t('gridNewUser', 'Новый', 'widget', translation, 'grid');
            case 'send':
            case 'delivered':
                return t('grid-Sended', 'Отправлено', 'widget', translation, 'grid');
            case 'rejected':
            case 'canceled':
                return t('grid-Rejected', 'Отклонено', 'widget', translation, 'grid');
            case 'processed':
                return t('grid-InProcess', 'В процессe', 'widget', translation, 'grid');
            case 'payed':
                return t('grid-payed', 'Оплачен', 'widget', translation, 'grid');
            case 'not_payed':
                return t('grid-not_payed', 'Не оплачен', 'widget', translation, 'grid');
            case 'no_payed':
                return t('grid-not_payed', 'Не оплачен', 'widget', translation, 'grid');
            default:
                return '';
        }
    };
    if (val?.component && React.isValidElement(val?.component)) return val?.component;
    return (
        <div {...getHandlers(false)} style={stylers.wrapper} className={classes.wrapper} key={generateUniqueId()}>
            {val?.alias === 'loader' || val?.value === 'loader' || val === 'loader' ? (
                <CircleLoader />
            ) : (
                <p
                    style={stylers[val?.alias || val?.value || val]}
                    className={classnames(
                        existCl(val?.alias || val?.value || val) || css.orderStatus,
                        css[`status_${val?.alias || val?.value || val}`] || css.status_default
                    )}
                >
                    <p className={classnames(css.statusWrapper, !!val?.hint ? css.statusWrapperMod : '')}>
                        {val?.text ||
                            getStatusText(val?.alias || val?.value || val, val?.sex === 'male', typeof val === 'string')}
                        {!!val?.hint && (
                            <div className={css.hintWrapper}>
                                <Tooltip
                                    text={screenWidth ? val?.mobile || val?.hint : val?.hint}
                                    className={screenWidth ? 'react-tooltip-mg' : 'react-tooltip-lg-custom'}
                                >
                                    {svgSprite('info-circle', { className: css.formStatusIcon })}
                                </Tooltip>
                            </div>
                        )}
                    </p>
                </p>
            )}
        </div>
    );
};
Status.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string]),
    styles: PropTypes.object,
    name: PropTypes.string
};
export default Status;
